import { timelineEvents } from '@/mocks/data';

export default function TimelineSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            人生时间线
          </h2>
          <p className="text-foreground-500 text-base">
            饭岛爱36年人生中的重要时刻
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>

          <div className="flex flex-col gap-8">
            {timelineEvents.map((event, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <div
                  key={event.year}
                  className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-0 ${
                    isLeft ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="flex items-center gap-4 md:w-1/2 md:justify-end md:pr-10">
                    <div className="md:hidden w-8 h-8 flex items-center justify-center">
                      <div className="w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100 flex-shrink-0"></div>
                    </div>
                    <div className={`text-left ${isLeft ? 'md:text-right' : 'md:text-left'}`}>
                      <span className="inline-block text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                        {event.year}
                      </span>
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                        {event.title}
                      </h3>
                      <p className="text-foreground-500 text-sm leading-relaxed">
                        {event.description}
                      </p>
                    </div>
                  </div>

                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 z-10">
                    <div className="w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100"></div>
                  </div>

                  <div className="hidden md:block md:w-1/2 md:pl-10"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}